let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aW45P")).then(() => parcelRequire('7ZpXJ'));